import create from "zustand"
import { immer } from "utils/zustand.utils"

// ten colors in hsl
export const SALESMEN_COLORS = [
  "red",
  "orange",
  "amber",
  "yellow",
  "lime",
  "green",
  "teal",
  "sky",
  "indigo",
  "purple",
  "pink",
]

type SalesManColorMapStore = {
  /**
   * @description The color map where salesman id is the key and the color is the value
   * eg { "1": { hue: 0, saturation: 0, lightness: 0 } }
   */
  colors: Record<string, string>
  setColorMap: (users: any[]) => void
}
const useSalesManColorMap = create<SalesManColorMapStore>(
  immer(set => ({
    colors: {},
    setColorMap(users) {
      if (!users.length) return
      set(prev => {
        prev.colors = users.reduce((acc, user) => {
          acc[user.id] = user.color
          return acc
        }, {})
      })
    },
  }))
)

export default useSalesManColorMap
